var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "preparacionEquipos" },
    [
      _vm.showModalNew
        ? _c("ModalCrear", { on: { cerrar: _vm.handleCierreModalCrear } })
        : _vm._e(),
      _vm.showModalAsignacion
        ? _c("ModalAsignacion", {
            attrs: {
              show: _vm.showModalAsignacion,
              registroSeleccionado: _vm.registroSeleccionado,
              data: _vm.data
            },
            on: {
              FinalizarClick: _vm.handleFinalizarClick,
              cerrar: _vm.handleCierreModalAsignacion
            }
          })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "layout wrap widgets my-3" },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", layout: "", wrap: "" } },
            [
              _c("FiltrosBusqueda", {
                attrs: {
                  formFields: _vm.formFields,
                  listaReq: _vm.listaReq,
                  estadosList: _vm.estadosList,
                  razonsocialList: _vm.razonsocialList
                },
                on: {
                  resultadoBusqueda: _vm.filtroAlertas,
                  clear: _vm.AlertaInicial
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", "my-1": "" } },
            [_c("v-divider")],
            1
          ),
          _c(
            "v-flex",
            {
              attrs: {
                sm12: "",
                layout: "",
                wrap: "",
                "justify-end": "",
                "align-center": "",
                "ma-0": ""
              }
            },
            [
              _c(
                "div",
                { staticClass: "text-sm-center botones-filtros" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btn_exportar("series")
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("Detalle Series")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "text-sm-center botones-filtros" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", small: "", color: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.btn_exportar("grilla")
                        }
                      }
                    },
                    [
                      _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                        _vm._v("cloud_download")
                      ]),
                      _vm._v("  \n          "),
                      _c("span", { staticClass: "importExportBtnTexto" }, [
                        _vm._v("Exportar"),
                        _c("br"),
                        _vm._v("CSV")
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              false
                ? _c(
                    "v-btn",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: { color: "#ffe800" },
                      on: {
                        click: function($event) {
                          _vm.showModalNew = true
                        }
                      }
                    },
                    [
                      _c(
                        "v-icon",
                        {
                          staticStyle: { color: "black" },
                          attrs: { dark: "", left: "" }
                        },
                        [_vm._v("add_circle_outline")]
                      ),
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v("Crear")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card camaras preparacionscroll" },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                "offset-md10": "",
                "offset-sm10": "",
                sm2: "",
                md2: "",
                hide: ""
              }
            },
            [
              _c("v-text-field", {
                staticStyle: { "margin-right": "5px" },
                attrs: { label: "Buscar..." },
                on: { input: _vm.searchData },
                model: {
                  value: _vm.filtrobusquedagrilla,
                  callback: function($$v) {
                    _vm.filtrobusquedagrilla = $$v
                  },
                  expression: "filtrobusquedagrilla"
                }
              })
            ],
            1
          ),
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.dialogVerEstadoSerie
        ? _c("ModalVerEstadoSeries", {
            attrs: { data: _vm.data, show: true },
            on: { cerrar: _vm.handleCierreModalAsignacion }
          })
        : _vm._e(),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/conecta-reportes"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e(),
      _vm.dialogSerieList
        ? _c("ModalSeries", {
            attrs: { data: _vm.data, funcionalidad: _vm.funcionalidad },
            on: {
              closeModalSeries: _vm.handleCierreModalSeries,
              finalizarCompleto: _vm.handleCierreModalAsignacion
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }